import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import SystemLogListView from './components/SystemLogListView';
import SystemLogListScreen from './screens/SystemLogListScreen';

ChargeSystemLog.propTypes = {};

function ChargeSystemLog(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<SystemLogListScreen />} />
          <Route path=":systemLogId" element={<SystemLogListView />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeSystemLog;
